export enum BenefitLevel {
  Limited = '01',
  Full = '02',
  None = '03',
}
